function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    "data-inject-url": "https://edublink.html.devsblink.com/assets/images/animated-svg-icons/online-degree.svg",
    className: "svgInject",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.70459 25.5939L12.8535 30.8403C13.015 31.0021 13.11 31.2307 13.11 31.4592V35.0298C13.11 35.4106 13.3475 35.7439 13.699 35.8676C15.0575 36.3342 18.4679 36.7341 20.9664 38.8574C21.5364 39.3335 22.4009 38.905 22.4009 38.1719V34.3918C22.4009 32.9921 23.4744 31.8496 24.8613 31.7067C27.1033 31.4592 30.0483 29.9452 29.8773 23.6325C29.8678 23.1373 30.2763 22.7279 30.7702 22.7279H31.8247C32.8507 22.7279 33.4112 21.5377 32.7557 20.7474L29.6873 17.015C29.3928 16.6627 29.2313 16.2057 29.2313 15.7486V10.2833C29.2503 6.19852 25.8683 0.952148 19.4559 0.952148C13.0435 0.952148 8.72108 3.58009 8.72108 6.4556",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "86, 88",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1014 5.98926V23.9945C24.1014 24.9752 23.3129 25.7655 22.3344 25.7655H20.1779C19.9499 25.7655 19.7409 25.8798 19.6269 26.0797L17.9739 28.7648C17.9169 28.8505 17.8029 28.8695 17.7269 28.8029L14.554 25.9369C14.4305 25.8322 14.2785 25.7655 14.117 25.7655H2.71717C1.73868 25.7655 0.950195 24.9657 0.950195 23.9945V7.88404C0.950195 6.90333 1.73868 6.11304 2.71717 6.11304H18.7624",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "81, 83",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2168 17.5674C13.1717 17.5674 13.9457 16.7915 13.9457 15.8345C13.9457 14.8774 13.1717 14.1016 12.2168 14.1016C11.2619 14.1016 10.4878 14.8774 10.4878 15.8345C10.4878 16.7915 11.2619 17.5674 12.2168 17.5674Z",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11, 13",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70456 12.9688C8.65945 12.9688 9.43354 12.1929 9.43354 11.2359C9.43354 10.2788 8.65945 9.50293 7.70456 9.50293C6.74967 9.50293 5.97559 10.2788 5.97559 11.2359C5.97559 12.1929 6.74967 12.9688 7.70456 12.9688Z",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11, 13",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7295 12.9688C17.6843 12.9688 18.4584 12.1929 18.4584 11.2359C18.4584 10.2788 17.6843 9.50293 16.7295 9.50293C15.7746 9.50293 15.0005 10.2788 15.0005 11.2359C15.0005 12.1929 15.7746 12.9688 16.7295 12.9688Z",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11, 13",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70456 22.167C8.65945 22.167 9.43354 21.3912 9.43354 20.4341C9.43354 19.477 8.65945 18.7012 7.70456 18.7012C6.74967 18.7012 5.97559 19.477 5.97559 20.4341C5.97559 21.3912 6.74967 22.167 7.70456 22.167Z",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11, 13",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7295 22.167C17.6843 22.167 18.4584 21.3912 18.4584 20.4341C18.4584 19.477 17.6843 18.7012 16.7295 18.7012C15.7746 18.7012 15.0005 19.477 15.0005 20.4341C15.0005 21.3912 15.7746 22.167 16.7295 22.167Z",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "11, 13",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3472 14.5296L15.4656 12.4062",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9152 14.7009L8.73975 12.5205",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "4, 6",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8582 17.7295L8.73975 19.8528",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2808 17.5576L15.4657 19.738",
    stroke: "#1ab69d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "4, 6",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4507 6.55079C21.692 6.55079 21.8877 6.35469 21.8877 6.1128C21.8877 5.8709 21.692 5.6748 21.4507 5.6748C21.2093 5.6748 21.0137 5.8709 21.0137 6.1128C21.0137 6.35469 21.2093 6.55079 21.4507 6.55079Z",
    stroke: "#1ab69d",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory1);
export default __webpack_public_path__ + "static/media/category-1.19210e9f6063b7afd9fe932f95251d41.svg";
export { ForwardRef as ReactComponent };